<svg [ngClass]="class" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_17595_4876)">
    <path d="M4.5 14.25C4.5 15.075 5.175 15.75 6 15.75H12C12.825 15.75 13.5 15.075 13.5 14.25V5.25H4.5V14.25ZM14.25 3H11.625L10.875 2.25H7.125L6.375 3H3.75V4.5H14.25V3Z"
          [style.fill]="fillColor"/>
  </g>
  <defs>
    <clipPath id="clip0_17595_4876">
      <rect width="18" height="18" fill="white"/>
    </clipPath>
  </defs>
</svg>

